import React from 'react';
import { painClose, painIntro, painPoints } from '../data/painPoints';
import { OFFER_ANCHOR } from './constants';
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-4" data-id="element-93" data-mp="38vu684fcdz20">
      <div className="mx-auto max-w-4xl" data-id="element-94" data-mp="2uxm2ndnsvzhv">
        <h2 className="mb-1.5 text-center font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-95" data-mp="2yzh4qkdk2gwp">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mb-2.5 max-w-3xl space-y-1 text-center text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-96" data-mp="2l719w6ut5p6v">
          {painIntro.map(line => <p key={line} data-id="element-97" data-mp="2bbhcfg0liig0">{line}</p>)}
          <p className="font-semibold text-brand-navy" data-id="element-98" data-mp="2g9988l4d2oph">{painClose}</p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-99" data-mp="2g6wr2a6fgidh">
          {painPoints.map(point => <a key={point.title} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border-l-4 border-brand-gold bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-100" data-mp="22bkurycmijug">
              <h3 className="mb-1 font-head text-[14px] font-bold uppercase leading-tight text-brand-navy sm:text-lg" data-id="element-101" data-mp="3nkdzvdbwsx6t">
                {point.title}
              </h3>
              {point.lines.map(line => <p key={line} className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-102" data-mp="h968s5qztnj">
                  {line}
                </p>)}
            </a>)}
        </div>
      </div>
    </section>;
}